import React from 'react';
import { Editable } from '~/components/Form';
import { filenameParts } from '~/util';
import { ReferralAttachmentType } from '../ReferralAttachments';

export interface ReferralFileListProps {
    attachments: ReferralAttachmentType[];
    setAttachments: React.Dispatch<React.SetStateAction<ReferralAttachmentType[]>>;
    setEditing: (x: boolean) => void;
}
export function ReferralFileList({
    attachments,
    setAttachments,
    setEditing,
}: ReferralFileListProps) {
    const [editingId, setEditingId] = React.useState<null | number>(null);

    function removeFile(removedFile: ReferralAttachmentType) {
        setAttachments((prevAttachments) =>
            prevAttachments.filter((attachment) => attachment.id !== removedFile.id)
        );
    }

    function saveFilename(id: number, name: string) {
        setAttachments((prevAttachments) =>
            prevAttachments.map((attachment) =>
                attachment.id === id
                    ? {
                          id,
                          file: new File(
                              [attachment.file],
                              `${name}.${attachment.file.name.split('.').pop()}`,
                              { type: attachment.file.type }
                          ),
                      }
                    : attachment
            )
        );
        setEditingId(null);
        setEditing(false);
    }

    return (
        <>
            {attachments.map((attachment) => (
                <div className="row" key={attachment.id}>
                    <div className={editingId === null ? 'col-10' : 'col-12'}>
                        <div className={editingId !== attachment.id ? 'text-ellipsis' : ''}>
                            <Editable
                                handleCancel={() => setEditingId(null)}
                                handleSave={(name) => saveFilename(attachment.id, name)}
                                isEditing={editingId === attachment.id}
                                placeholder="Filename"
                                readonlyText={filenameParts(attachment.file.name)[1]}
                                writeableText={filenameParts(attachment.file.name)[0] as string}
                            />
                        </div>
                    </div>
                    {editingId === null && (
                        <div className="col-2 text-end">
                            <button
                                className="icon-button"
                                type="button"
                                tabIndex={0}
                                onClick={() => {
                                    setEditingId(attachment.id);
                                }}
                            >
                                <i className="fa-solid fa-pencil" aria-label="Edit" />
                            </button>
                            <button
                                className="icon-button"
                                type="button"
                                tabIndex={0}
                                onClick={() => removeFile(attachment)}
                                onKeyPress={() => removeFile(attachment)}
                            >
                                <i
                                    className="fa-solid fa-lg fa-times text-danger cursor-pointer"
                                    aria-label="Remove Attachment"
                                />
                            </button>
                        </div>
                    )}
                </div>
            ))}
        </>
    );
}
